module.exports = __webpack_public_path__ + "static/ai-pmp-activation-58d9c324397fddec1c928194a5f5ea7a.svg";